// import routes
import homepage from "./routes/homepage";
import dieta from "./routes/dieta";
import dopasuj from "./routes/dopasuj";
import dostawy from "./routes/dostawy";
import cennik from "./routes/cennik";
import miasta from "./routes/miasta";
import blog from "./routes/blog";
import gsap from "gsap";
import Cookies from 'js-cookie'

// GSAP Plugins
// gsap.registerPlugin(ScrollTrigger);

export default {
    init() {
        // JavaScript to be fired on all pages
        /* all scripts including header, footer etc. */
        // console.log('COMMON INIT');

        if (document.body.classList.contains('home')) {
          homepage.init();
        } else if (document.body.classList.contains('page-template-template-dopasuj-diete')) {
          dopasuj.init();
        } else if (document.body.classList.contains('page-template-template-strefy-dostaw')) {
          dostawy.init();
        } else if (document.body.classList.contains('page-template-template-cennik')) {
          cennik.init();
        } else if (document.body.classList.contains('single-nasze-diety')) {
          dieta.init();
        } else if (document.body.classList.contains('single-catering-dietetyczny')) {
          miasta.init();
        } else if (document.body.classList.contains('blog')) {
          blog.init();
        }

        // MENU DROPDOWN
        $(document).ready(function() {

          $('a[href*=#]:not([href=#])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                $('html,body').animate({
                  scrollTop: target.offset().top-150,
                }, 10);
                return false;
              }
            }
          });

          const dropdown = $('#diets-dropdown');
          const dropdownBtn = $('.diety-dropdown');
          const dropdownContainer = $('#dieta-menu-desktop-container');

          if ($('body').hasClass('single-nasze-diety')) {
            dropdownContainer.append(dropdown);
          } else {
            dropdownBtn.append(dropdown);
          }

          let menuDropdownAnimation = gsap.timeline({paused: true, reversed: false});
          menuDropdownAnimation.set('#diets-dropdown', {'display' :'flex'});
          menuDropdownAnimation.to( '#diets-dropdown',{scaleY: 1, duration: 0.5, ease: 'Expo.easeInOut'});
          menuDropdownAnimation.to( '.single-diet-menu-item',{opacity: '1', duration: 0.05, ease: 'Expo.easeInOut',  stagger: 0.03});

          $('.diety-dropdown').on('mouseenter', function() {
            if ($(window).width() >= 992 && !$('body').hasClass('single-nasze-diety'))  {
              menuDropdownAnimation.play();
              $(this).addClass('activeHover');
            }
          });

          $('.diety-dropdown').on('mouseleave', function() {
            if ($(window).width() >= 992 && !$('body').hasClass('single-nasze-diety'))  {
              menuDropdownAnimation.reversed();
              menuDropdownAnimation.reverse();
              setTimeout(function() {
                $('.diety-dropdown').removeClass('activeHover');
              }, 200);
            }
          });

          $('li.diety-dropdown > a').click(function(event) {
            event.preventDefault();

            if ($(window).width() >= 992) {
              // DESKTOP CLICK - NASZE DIETY
              if ($('body').hasClass('page-template-template-homepage')) {
                console.log('clicked on homepage');
                $('html, body').animate({
                  scrollTop: $('#poznaj-nasze-diety').offset().top - 200,
                }, 500);
                return false;
              }
              console.log('clicked on NON homepage');
              location.href = window.location.origin + '/#nasze-diety';
            } else if ($(window).width() < 992) {
              // MOBILE CLICK - NASZE DIETY
              $('#offcanvas-mobile-menu').offcanvas('hide');
              $('#offcanvas-city').offcanvas('hide');
              const goToURL = $('#diets-dropdown a.single-diet-menu-item').attr('href');
              location.href = goToURL;
            }

          });

          if (window.location.hash == '#nasze-diety') {
            //console.log('wchodzi do scrolla do diet');
            $('html, body').animate({
              scrollTop: $('#poznaj-nasze-diety').offset().top - 200,
            }, 500);
          }

          // OFFCANVAS MENU - backdrop click fix
          $('.modal-backdrop').on('click', function () {
            $(this).removeClass('show');
          });

          // LOCATION COOKIE
          // console.log(Cookies.get('pysznafabryka-zone'));
          // console.log(Cookies.get('pysznafabryka-location'));
          const siteCityLabel01 = $('#city-label-01 strong');
          const siteCityLabel02 = $('#city-label-02 strong');
          const siteContainer = $('#content');
          let citySelected;
          let priceArea;
          let hoursSelected;

          if (Cookies.get('pysznafabryka-location') === undefined || Cookies.get('pysznafabryka-zone') === undefined || Cookies.get('pysznafabryka-hours') === undefined) {

            // console.log('! BRAK CIASTECZKA LOKALIZACYJNEGO !');

            console.log('>> USTAWIAM LOKALIZACJE DOMYŚLNĄ');
            siteCityLabel01.html('Łódź');
            siteCityLabel02.html('Łódź');
            siteContainer.attr('data-site-zone', 'strefa-0');
            siteContainer.attr('data-site-city', 'Łódź');
            siteContainer.addClass('strefa-0');

            // console.log('>> OTWIERAM OVERLAY CITY');
            // ZABLOKOWANY WYBOR MIASTA
            // $('#step-1-wojewodztwo-label').addClass('active');
            // $('#step-2-miasto-label').removeClass('active');
            // $('#offcanvas-city').offcanvas('show');

          } else {

            // console.log('! ODCZYTUJE CIASTECZKO LOKALIZACYJNE !');
            citySelected = Cookies.get('pysznafabryka-location');
            priceArea = Cookies.get('pysznafabryka-zone');
            hoursSelected = Cookies.get('pysznafabryka-hours');
            // console.log(citySelected);
            // console.log(priceArea);
            // console.log(hoursSelected);

            // console.log('>> USTAWIAM odczytaną lokalizację i strefe cen');
            siteCityLabel01.html(citySelected);
            siteCityLabel02.html(citySelected);
            siteContainer.attr('data-site-zone', priceArea);
            siteContainer.attr('data-site-city', citySelected);
            siteContainer.addClass(priceArea);
          }

          // CLICK province on the map // reset selection each click
          $('.province-map-btn').on('click', function () {
            // console.log('>> CLICK - województwo na mapie');
            const provinceSelected = $(this).attr('data-province');
            // console.log(provinceSelected);
            $('#city-confirm-btn').attr('disabled', true);
            $('.province-map-btn').removeClass('active');
            $(this).addClass('active');
            $('#miasta-list ul').removeClass('active');
            $('#step-1-wojewodztwo-label').removeClass('active');
            $('#step-2-miasto-label').addClass('active');
            $('#wojewodztwa-list').hide();
            $('#miasta-list').show();
            $('#miasta-list ul[data-province=' + provinceSelected + ']').addClass('active');
          });

          // CLICK province on the list
          $('.province-list-btn').on('click', function () {
            // console.log('>> CLICK - województwo na liście');
            const provinceSelected = $(this).attr('data-province');
            // console.log(provinceSelected);
            $('.province-map-btn').removeClass('active');
            $('.province-map-btn[data-province=' + provinceSelected + ']').addClass('active');
            $('#miasta-list ul').removeClass('active');
            $('#step-1-wojewodztwo-label').removeClass('active');
            $('#step-2-miasto-label').addClass('active');
            $('#wojewodztwa-list').hide();
            // MOBILE PART
            $('.miasta-list ul li').removeClass('active');
            $('#selected-wojewodztwo-mobile').html('woj. ' + provinceSelected);
            $('#step-1-wojewodztwo-mobile').hide();
            $('#selected-wojewodztwo-mobile').css('display', 'block');
            $('#step-2-miasto-mobile').css('display', 'block');
            // CITY PART
            $('#miasta-list').show();
            $('#miasta-list ul[data-province=' + provinceSelected + ']').addClass('active');
            if (window.innerWidth < 992) {
              $('.miasta-list ul li').attr('data-bs-dismiss', 'offcanvas');
            }
          });

          // MOBILE BACK BTN
          $('#back-to-province').on('click', function () {
            $('#selected-wojewodztwo-mobile').hide();
            $('#step-2-miasto-mobile').hide();
            $('#miasta-list').hide();
            $('#step-1-wojewodztwo-mobile').show();
            $('#wojewodztwa-list').show();
          });

          // CLICK city on the list
          $('.miasta-list ul li').on('click', function () {
            // console.log('>> CLICK - miasto na liście');
            citySelected = $(this).attr('data-miasto-label');
            priceArea = $(this).attr('data-strefa');
            hoursSelected = $(this).attr('data-godziny');
            // console.log(citySelected);
            // console.log(priceArea);
            $('.miasta-list ul li').removeClass('active');
            $(this).addClass('active');
            // SPRAWDZAM ROZDZIELCZOŚĆ
            if (window.innerWidth < 992) {
              // MOBILE
              // console.log('>> USTAWIAM wybraną lokalizację i strefe cen');
              // console.log('>> MOBILE');
              // console.log(citySelected);
              // console.log(priceArea);
              siteCityLabel01.html(citySelected);
              siteCityLabel02.html(citySelected);
              $('#current-city').html(citySelected);
              $('#current-zone').html(hoursSelected);
              siteContainer.attr('data-site-zone', priceArea);
              siteContainer.attr('data-site-city', citySelected);
              siteContainer.removeClass('strefa-0 strefa-1 strefa-2 strefa-3');
              siteContainer.addClass(priceArea);
              // UKRYWA OVERLAY i ZAPSIUJE INFORMACJE W CIASTECZU
              // $('#offcanvas-city').offcanvas('hide');
              // $('#offcanvas-mobile-menu').offcanvas('hide');
              $('body').css('overflow', '').css('padding-right', '')
              Cookies.set('pysznafabryka-location', citySelected);
              Cookies.set('pysznafabryka-zone', priceArea);
              Cookies.set('pysznafabryka-hours', hoursSelected);
            } else {
              // DESKTOP
              $('#city-confirm-btn').removeAttr('disabled');
            }
          });

          $('#city-confirm-btn').on('click', function () {
            // USTAWIAM wybraną lokalizację i strefe cen
            // console.log('>> USTAWIAM wybraną lokalizację i strefe cen');
            // console.log(citySelected);
            // console.log(priceArea);
            siteCityLabel01.html(citySelected);
            siteCityLabel02.html(citySelected);
            $('#current-city').html(citySelected);
            $('#current-zone').html(hoursSelected);
            siteContainer.attr('data-site-zone', priceArea);
            siteContainer.attr('data-site-city', citySelected);
            siteContainer.removeClass('strefa-0 strefa-1 strefa-2 strefa-3');
            siteContainer.addClass(priceArea);
            // CHOWAM OVERLAY i ZAPSIUJE INFORMACJE W CIASTECZU
            // console.log('==>> OFFCANVAS HIDE');
            $('#offcanvas-city').offcanvas('hide');
            // ZAPISUJE CIASTECZKO
            Cookies.set('pysznafabryka-location', citySelected);
            Cookies.set('pysznafabryka-zone', priceArea);
            Cookies.set('pysznafabryka-hours', hoursSelected);
            // SET DEFAULT BODY CLASSES
            // console.log('==>> BODY CLASSES');
            $('body').css('overflow', '').css('padding-right', '')
          });

        })

      // NAV BTNS
      $('#city-btn-01').on('click', function () {
        $('.miasta-list ul li').removeClass('active');
        $('.province-map-btn').removeClass('active');
        $('#step-1-wojewodztwo-label').addClass('active');
        $('#step-2-miasto-label').removeClass('active');
        $('#city-confirm-btn').attr('disabled', true);
        $('#selected-wojewodztwo-mobile').html('');
        $('#step-1-wojewodztwo-mobile').show();
        $('#selected-wojewodztwo-mobile').hide();
        $('#step-2-miasto-mobile').hide();
        $('#miasta-list').hide();
        $('#wojewodztwa-list').show();
        $('#offcanvas-mobile-menu').offcanvas('hide');
        $('#offcanvas-city').offcanvas('show');
      });

      $('#city-btn-02').on('click', function () {
        $('#selected-wojewodztwo-mobile').html('');
        $('#step-1-wojewodztwo-mobile').show();
        $('#selected-wojewodztwo-mobile').hide();
        $('#step-2-miasto-mobile').hide();
        $('#miasta-list').hide();
        $('#wojewodztwa-list').show();
        $('#offcanvas-mobile-menu').offcanvas('hide');
        $('#offcanvas-city').offcanvas('show');
      });

      $('#hamburger-btn').on('click', function () {
        $('#offcanvas-city').offcanvas('hide');
        $('#offcanvas-mobile-menu').offcanvas('show');
      });

      $('#hamburger-close-btn').on('click', function () {
        $('#offcanvas-city').offcanvas('hide');
        $('#offcanvas-mobile-menu').offcanvas('hide');
        $('body').css('overflow', '').css('padding-right', '')
      });

      $('#close-offcanvas-city').on('click', function () {

        // console.log('! ODCZYTUJE CIASTECZKO LOKALIZACYJNE !');
        const citySelected = Cookies.get('pysznafabryka-location');
        const priceAreaSelected = Cookies.get('pysznafabryka-zone');
        const hoursSelected = Cookies.get('pysznafabryka-hours');
        // console.log(citySelected);
        // console.log(priceArea);
        // console.log(hoursSelected);

        const defaultCity = "Łódź";
        const defaultPriceArea = $('#miasta-list li[data-miasto-label="Łódź"]').attr('data-strefa');
        const defaultHours = $('#miasta-list li[data-miasto-label="Łódź"]').attr('data-godziny');
        // console.log(defaultCity);
        // console.log(defaultPriceArea);
        // console.log(defaultHours);

        if (citySelected === undefined & priceAreaSelected === undefined & hoursSelected === undefined) {
          // console.log('BRAK WYBRANEJ LOKALIZACJI -> DEFAULT')

          $('#city-label-01 strong').html(defaultCity);
          $('#city-label-02 strong').html(defaultCity);
          $('#content').attr('data-site-city', defaultCity);
          $('#content').addClass(defaultPriceArea);

          Cookies.set('pysznafabryka-location', defaultCity);
          Cookies.set('pysznafabryka-zone', defaultPriceArea);
          Cookies.set('pysznafabryka-hours', defaultHours);
        }

        // $('#offcanvas-city').offcanvas('hide');
        // $('body').css('overflow', '').css('padding-right', '')
      });

      // FOOTER - CITIES BTN

      $('#more-cities-btn').on('click', function () {
        if ($(this).hasClass('active')) {
          $('#cities-hidden-row').slideUp();
          $('#more-cities-label').text('ZOBACZ WSZYSKIE MIASTA');
          $(this).removeClass('active');
        } else {
          $('#cities-hidden-row').slideDown();
          $('#more-cities-label').text('POKAŻ MNIEJ');
          $(this).addClass('active');
        }
      });

      // RESOLUTION CHANGE RESET ->>> MOBILE
      function resetToMobileDefault()
      {

      }

      // RESOLUTION CHANGE RESET ->>> DESKTOP
      function resetToDesktopDefault()
      {

      }

      // RESET ON RESIZE - WINDOWS RESIZE -> WIDTH CHANGE ONLY
      let width = $(window).width();
      $(window).on('resize', function () {
        if ($(this).width() !== width) {
          width = $(this).width();
          //RESET ON RESIZE
          if (window.innerWidth >= 992) {
            resetToDesktopDefault();
          } else {
            resetToMobileDefault();
          }
        }
      });

    },
}
